module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "row title-box-wrapper"
  }, [_c('div', {
    staticClass: "col-lg-11"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.t(_vm.title)))])]), _vm._v(" "), (_vm.showToggleFilterButton) ? _c('div', {
    staticClass: "col-lg-1"
  }, [_c('toggle-button', {
    staticClass: "pull-right toggle-button",
    attrs: {
      "value": _vm.toggleButtonValue,
      "height": 25,
      "width": 100,
      "labels": {
        checked: _vm.t('Hide filters'),
        unchecked: _vm.t('Show filters')
      }
    },
    on: {
      "change": _vm.toggleFilterPanel
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bd64442!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PanelHeader.vue
// module id = 1329
// module chunks = 2